import { Dispatch } from '@reduxjs/toolkit';
import {connect} from "react-redux";

import LoginView from "../view/login_view";
import { requestLoginFromAPI, requestResetFromAPI } from '../thunk/request_login_func';
import { RootState } from '../../../app/store';
import { loginActions } from '../actions/LoginAction';

function mapStateToProps(state:RootState){
    const myprops=
    {
        loginstatus:state.LoginManager.view.loginStatus,
        loginuser:state.LoginManager.model.username,
        lpw:state.LoginManager.view.password,

        localtest: "string", // fill this with value no reference
    }
    
    return myprops;

}



function bindDispatchToActions(dispatch:Dispatch<any>, ownProps:any){
    return {
        onSubmit:(data:any, password:string)=>{
            console.log(data);
            const encode = (str: string):string => btoa(str);
            const passhash = encode(password);

            dispatch(loginActions.setUserAndPassword({user:data,pw:passhash}) as any);
            dispatch(requestLoginFromAPI(data, passhash, ownProps?.history)  as any);
            console.log("Dispatch should be done");
        },
        onLogout:()=>{
            dispatch(loginActions.setUserAndPassword({user:"",pw:""}) as any);
            dispatch(loginActions.revokeLogin("")  as any);
            console.log("Logout should be done");
        },
        onValueChange:(data:string, parameter:string) => {
            dispatch(loginActions.setValueChange({data:data, parameter:parameter}));
        },
        onSendPWReset:(user:string) => {
            dispatch(requestResetFromAPI(user) as any);
        },
        
    }
}

const LoginContainer=connect(mapStateToProps, bindDispatchToActions)(LoginView);
export default LoginContainer;